import React, { useMemo, useContext, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const CustomerDocumentDetails = () => {
  const { documentId } = useParams();
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);
  const [showDelete, setShowDelete] = useState(false);

  const decodedId = documentId ? atob(documentId) : documentId;
  const id = decodedId ? decodedId.replace(/\D/g, '') : '';

  const url = id ? `${API_DOMAIN}${API_ROUTES.customerDocument}${id}/` : null;
  const { data: document, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!document) return [];
    const excluded = ['id', 'created_at', 'updated_at'];
    return Object.keys(document)
      .filter(k => !excluded.includes(k))
      .map(k => ({ label: k.charAt(0).toUpperCase() + k.slice(1).replace(/_/g, ' '), field: k }));
  }, [document]);

  const handleDelete = async () => {
    try {
      await axios.delete(`${API_DOMAIN}${API_ROUTES.customerDocument}${id}/`);
      showToast('Document deleted successfully', 'success');
      navigate('/customer/document/list');
    } catch (error) {
      console.error('Error deleting document:', error);
      showToast('Error deleting document', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={document}
        columns={columns}
        loading={loading}
        entityName="Document"
        listPath="/customer/document/list"
        editPath={`/customer/document/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        show={showDelete}
        title="Delete Document"
        message="Are you sure you want to delete this document?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default CustomerDocumentDetails;
